// extracted by mini-css-extract-plugin
export default {"gif":"n_6","gif--wrapped":"n_7"};